/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a translation for a given `key` is invalid
 * @export
 * @class I18nInvalidTranslationTypeError
 * @extends {Error}
 */
export class I18nInvalidTranslationTypeError extends Error {
  /**
   * Creates an instance of I18nInvalidTranslationTypeError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidTranslationTypeError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidTranslationTypeError`;
  }
}

/**
 * Called when the type of a translation for a given `key` is invalid
 * @param {string} key The `key` referecing the invalid translation
 * @param {any} value The `value` to use for the translation
 * @returns {never} never
 */
const throwI18nInvalidTranslationTypeError = (key, value) => {
  throw new I18nInvalidTranslationTypeError(
    stripIndent(`
    Expected the translation type for key "${key}", to be of type React.ReactElement, Function, Number, or String.
    Got: "${ctype(value)}".
    `),
  );
};

export default throwI18nInvalidTranslationTypeError;
